import { Button } from "@tellescope/design-system";
import { useTranslation } from "react-i18next";
import type { BlockingFieldError } from "../hooks/use-tellescope-enduser-form";

export interface FormBlockingErrorProps {
  blockingError: BlockingFieldError;
  onSelectField: (fieldId: string) => void;
}

export const FormBlockingError = ({ blockingError, onSelectField }: FormBlockingErrorProps) => {
  const { t } = useTranslation("forms");
  const { fieldId, title, error, isNavigable } = blockingError;
  const message = t("{{title}}: {{error}}", { title, error });

  if (!isNavigable) return <p className="text-sm text-destructive">{message}</p>;

  return (
    <Button
      variant="link"
      color="destructive"
      size="sm"
      className="h-auto justify-start whitespace-normal p-0 text-left"
      onClick={() => onSelectField(fieldId)}
    >
      {message}
    </Button>
  );
};
